import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "sort-up",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M11.5261 8.41785C11.8206 8.1776 12.2554 8.19521 12.53 8.4696L18.53 14.4696C18.7444 14.6841 18.8091 15.0067 18.6931 15.287C18.577 15.5672 18.303 15.7499 17.9997 15.7499H5.99969C5.69647 15.7498 5.42238 15.5671 5.30634 15.287C5.19043 15.0068 5.25508 14.684 5.46942 14.4696L11.4694 8.4696L11.5261 8.41785Z",
			fill: "currentColor"
		})
	})
});
export default SvgSortUp;
